import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import ScrollToTop from "@/components/ScrollToTop";
import LandingPage from "@/pages/LandingPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";

const ZALMA_URL = process.env.REACT_APP_ZALMA_URL || "https://www.zalma.com.au";

// Marketing-side product alias: zapai.com.au/pet-grooming → zalma.com.au.
// Renders a tiny placeholder while the browser navigates externally so users
// don't see a flash of the landing page.
function PetGroomingRedirect() {
  useEffect(() => {
    window.location.replace(ZALMA_URL);
  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Manrope, system-ui, sans-serif",
      color: "#475569",
      fontSize: 14,
    }}>
      Redirecting to Zalma…
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/pet-grooming" element={<PetGroomingRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
